module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/ecp-logo-big-c6db72ade5a0e88414bdf2e882f67d61.png";